import { getEnvironment, Environment } from './environment-utils';

export const getRootUrl = () => {
  const env = getEnvironment(window.location.host);
  switch (env) {
    case Environment.PROD:
      return 'https://ads.microsoft.com';
    case Environment.BETAPROD:
      return 'https://beta.ads.microsoft.com';
    case Environment.TIP:
      return 'https://tip.ads.microsoft.com';
    case Environment.SI:
      return 'https://ads-int.microsoft.com';
    case Environment.BETASI:
      return 'https://beta.ads-int.microsoft.com';
    default:
      return 'http://advertiseruibox.redmond.corp.microsoft.com';
  }
};

export const getOdataRootUrl = (params?: { domain?: string, accountId?: string, customerId?: string, search?: string }) => {
  const domain = params?.domain || window.location.host;
  const search = params?.search || window.location.search;
  const env = getEnvironment(domain, search);

  let url: string;
  switch (env) {
    case Environment.PROD:
      url = 'https://ui.ads.microsoft.com';
      break;
    case Environment.BETAPROD:
      url = 'https://ui.beta.ads.microsoft.com';
      break;
    case Environment.TIP:
      url = 'https://ui.tip.ads.microsoft.com';
      break;
    case Environment.SI:
      url = 'https://ui.ads-int.microsoft.com';
      break;
    case Environment.BETASI:
      url = 'https://ui.beta.ads-int.microsoft.com';
      break;
    default:
      url = 'http://advertiseruibox.redmond.corp.microsoft.com:18080';
      break;
  }

  if (domain.search(/aks/) !== -1) {
    url = `https://${domain.startsWith('ui.') ? '' : 'ui.'}${domain}`;
  }

  if (params?.customerId) {
    url += env === Environment.CI ? '/ODataApi/Advertiser/V2' : '/ODataApi/Campaign/V2';
    url += `/Customers(${params.customerId})`;
    if (params.accountId) {
      url += `/Accounts(${params.accountId})`;
    }
  }

  return url;
};

type Platform = 'EXPERT' | 'CC' | 'SMART_CAMPAIGN';

export const Platforms: Record<Platform, Platform> = {
  EXPERT: 'EXPERT',
  SMART_CAMPAIGN: 'SMART_CAMPAIGN',
  CC: 'CC',
};

export const getPlatform = (url: string) => {
  if (url.includes('/campaign/smart')) {
    return Platforms.SMART_CAMPAIGN;
  }
  if (url.includes('/cc/')) {
    return Platforms.CC;
  }
  return Platforms.EXPERT;
};

export interface ILogger {
  trace(str: string): void;
  error(str: string): void;
  info(str: string): void;
}
